import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';

@Component({
  selector: 'rqa-changes-popup',
  standalone: true,
  imports: [CommonModule, ButtonModule, DialogModule, TranslateModule],
  template: `
    <p-dialog
      [(visible)]="display"
      [modal]="true"
      [style]="{ width: '50vw' }"
      [draggable]="false"
      [resizable]="false"
      [closeOnEscape]="true"
      [closable]="true"
    >
      <ng-template pTemplate="header">
        <h2 class="m-0">{{ 'changes.popup.title' | translate }}</h2>
      </ng-template>
      <div class="flex flex-column">
        <p class="m-0 pre-wrap">{{ 'changes.popup.content' | translate }}</p>
        <p class="m-0" [innerHTML]="'changes.popup.help' | translate" (click)="handleLinkClick($event)"></p>
        <p class="m-0">{{ 'changes.popup.contact' | translate }}</p>
      </div>
      <ng-template pTemplate="footer">
        <div class="flex justify-content-end">
          <p-button
            [label]="'changes.popup.helpButton' | translate"
            (click)="navigateToHelp()"
            styleClass="p-button-primary"
          />
        </div>
      </ng-template>
    </p-dialog>
  `,
  styles: `
    .pre-wrap {
      white-space: pre-wrap;
    }
  `
})
export class ChangesPopupComponent implements OnInit {
  display = false;
  private readonly COOKIE_NAME = 'webrqa_changes_popup';
  private readonly COOKIE_EXPIRY = 5 * 365; // 5 years in days

  constructor(
    private cookieService: CookieService,
    private router: Router
  ) {}

  ngOnInit() {
    if (!this.cookieService.check(this.COOKIE_NAME)) {
      this.display = true;
    }
  }

  handleLinkClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (target.tagName === 'A') {
      event.preventDefault();
      const href = target.getAttribute('href');
      if (href) {
        this.router.navigate([href]);
        this.onClose();
      }
    }
  }

  onClose() {
    this.display = false;
    this.cookieService.set(this.COOKIE_NAME, 'shown', this.COOKIE_EXPIRY);
  }

  navigateToHelp() {
    this.onClose();
    this.router.navigate(['/help']);
  }
}
